/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const InfoCircle = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M10 3c3.8 0 7 3.1 7 7 0 3.8-3.1 7-7 7-3.8 0-7-3.1-7-7 0-3.8 3.1-7 7-7zm0-1c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM8.8 13.1h.4V9.2h-.4c-.2 0-.4-.2-.4-.4v-.2c0-.2.2-.4.4-.4h1.5c.2 0 .4.2.4.4v4.5h.4c.2 0 .4.2.4.4v.3c0 .2-.2.4-.4.4H8.8c-.2 0-.4-.2-.4-.4v-.3c.1-.2.2-.4.4-.4zM10 5.4c-.6 0-1 .5-1 1s.5 1 1 1 1-.5 1-1-.4-1-1-1z" />
  </svg>
);

export default extendIcon(InfoCircle);
